import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const TiktokIcon: React.FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="-25 -25 550 550" {...props}>
      <path
        d="M1325 4679c-255-7-341-19-464-65-189-71-365-240-455-436-43-93-62-162-75-268-15-117-15-2714 0-2830 12-101 57-242 
        104-325 69-124 199-252 325-323 80-45 223-90 331-103 111-15 2045-20 2539-8 256 7 318 11 387 28 170 42 273 100 400 
        224 130 126 191 234 236 416 20 84 21 111 26 1281 7 1405 3 1622-33 1761-79 311-331 555-637 620-158 33-470 41-1494 
        37-522-2-1058-6-1190-9zm1825-528c0-5 5-44 11-87 22-162 115-333 243-451 163-149 355-243 496-243 35 0 38-3 44-32 
        4-25 10-456 6-535 0-9-20-13-67-13-205 0-470 81-668 204-22 13-43 22-47 20-5-3-8-287-7-632 0-408-4-646-11-682-42-217
        -173-442-343-590-208-181-443-266-727-263-224 2-419 68-594 199-150 113-248 225-317 364-139 282-156 545-55 849 82 
        247 310 485 574 602 143 63 195 73 387 73l170 1 3-292c2-231 0-293-10-293-7 0-42 5-78 11-86 14-174-2-267-48-95-46-191
        -145-223-230-75-196-40-376 100-514 127-126 282-174 434-134 184 48 319 183 355 354 8 38 12 388 12 1204 0 633 2 1154 
        5 1159 7 11 574 10 574-1z"
        transform="matrix(.1 0 0 -.1 0 500)"
      ></path>
    </SvgIcon>
  );
};
